import { Trophy, Zap } from "lucide-react";
import { IMAGES, ATHLETIC_PROFILE } from "@/lib/content";
import { Reveal, Eyebrow } from "@/components/site/ui";

export function Athletics() {
  return (
    <section id="athletics" className="py-24 md:py-32 bg-gradient-to-b from-ivory to-blush/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-center">
          <Reveal>
            <div className="overflow-hidden rounded-[2rem] border border-champagne/30 shadow-[0_20px_50px_rgba(184,122,91,0.15)]">
              <img src={IMAGES.finishWin} alt="Leah Thames winning a 400m race" className="w-full object-cover object-top aspect-[4/5]" />
            </div>
          </Reveal>
          <div>
            <Reveal><Eyebrow>Athletic Profile</Eyebrow></Reveal>
            <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-6xl text-ink">Built For Big Stages.</h2></Reveal>

            <Reveal delay={0.1}>
              <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
                {[
                  { label: "Primary Events", value: ATHLETIC_PROFILE.primaryEvent },
                  { label: "400m PB", value: ATHLETIC_PROFILE.personalBest },
                  { label: "200m PB", value: ATHLETIC_PROFILE.personalBest200 },
                  { label: "Specialty", value: ATHLETIC_PROFILE.specialty },
                ].map((s) => (
                  <div key={s.label} className="rounded-2xl bg-ink text-ivory p-5 text-center">
                    <p className="font-heading text-xl md:text-2xl">{s.value}</p>
                    <p className="mt-1 label-eyebrow !text-champagne">{s.label}</p>
                  </div>
                ))}
              </div>
            </Reveal>

            <div className="mt-8 grid sm:grid-cols-2 gap-8">
              <Reveal delay={0.12}>
                <div>
                  <p className="label-eyebrow">Career Highlights</p>
                  <ul className="mt-4 space-y-3">
                    {ATHLETIC_PROFILE.highlights.map((h) => (
                      <li key={h} className="flex gap-3 font-body text-sm text-ink/80"><Trophy size={16} className="text-bronze shrink-0 mt-0.5" />{h}</li>
                    ))}
                  </ul>
                </div>
              </Reveal>
              <Reveal delay={0.18}>
                <div>
                  <p className="label-eyebrow">Available For</p>
                  <ul className="mt-4 space-y-3">
                    {ATHLETIC_PROFILE.availableFor.map((a) => (
                      <li key={a} className="flex gap-3 font-body text-sm text-ink/80"><Zap size={16} className="text-bronze shrink-0 mt-0.5" />{a}</li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
